<template>
	<dialog-slot
			title="All Filters"
			@updateClose="onDrawerClose"
			@updateSave="onSave"
			apply-text="Send filters"
			width="1300px"
	>
		<div class="wrapAllFilters">
			<div class="selectedFiltersWrap chooseFilters">
				<div class="head">Choose filters</div>
				<div class="main">
					<div
							v-for="(item, index) in headersWithFunc"
							:key="index"
							class="item"
							:class="[
							  item.value,
							  {
							    active:
							      isFilterSelected(item.valueFilter, (item.model && item.model.value) ? item.model.value : 'list') ||
							      filterClassesActive(item.value),
							  },
							  { lastTh: item.sticky },
							]"
					>

						<div class="wrapper">
							<div class="text" :class="[{ nowrap: item.nowrap }]">
								{{ item.text }}
							</div>
							<filter-drop-down v-if="item.func" :item="item">
								<filter-table
										:key="getFilterTableKey(item.valueFilter)"
										:external-value="filterModList[item.valueFilter]"
										@change-sort="changeSort"
										@create-refresh="createRefresh"
										@filter-created="filterCreated"
										@updatePerLoad="onPerLoad"
										@updateFilterListAll="onFilteredAll(item.valueFilter)"
										:flag="flag"
										:filtersList="filtersList"
										:data-filter="filtersList[item.valueFilter]"
										:defaultFilter="defaultFilter"
										:selectedAllElements="selectedAllElements"
										:item="item"
										:model-filter="item.valueFilter"
										:type-filter="item.model"
										:filter-update="isFilterUpdate"
										:refreshDate="isRefreshDate"
										:labelFilter="item.text"
										:isDisabled="isDisabled"
										:is-disabled="!!isRefresh"
										:isRefresh="isRefresh"
								></filter-table>
							</filter-drop-down>
						</div>

					</div>
				</div>
			</div>

			<div v-if="selectedFilters.length" class="selectedFiltersWrap cardItem">
				<div class="head">Selected filters</div>

				<div class="main">
					<div
							v-for="group in selectedFilters"
							:key="group.key"
							class="selItem"
					>
						<div class="nameRow">
							<div class="name">{{ group.text }}</div>

							<button
									type="button"
									class="clearAllBtn"
									@click="clearSelectedGroup(group)"
							>
								🗑 Clear all
							</button>
						</div>

						<div class="wrap">
							<div
									v-for="(chip) in group.items"
									:key="chip.key"
									class="item"
							>
								<div class="itemContent">
									<div class="value">{{ chip.value }}</div>

									<div
											class="delete"
											role="button"
											tabindex="0"
											@click="removeSelected(group, chip)"
									>
										<svg-sprite icon-id="close" width="18" height="18"/>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>
	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";
import FilterDropDown from "@/shared/FilterDropDown/FilterDropDown.vue";
import FilterTable from "@/shared/FilterTable/FilterTable.vue";
import formatDate from "@/helper/formatDate";

export default {
	name: "AllFilter",
	components: {
		// SortBtn,
		FilterTable,
		FilterDropDown,
		DialogSlot
	},
	props: {
		headers: Array,
		filtersList: Object,
		filterMod: Object,

		// ============
		checkAll: Boolean,
		indeterminate: Boolean,
		flag: String,
		list: Array,
		selectedAllElements: Object,
		defaultFilter: Object,
		isRefresh: String,
		isFilterUpdate: Boolean,
		isRefreshDate: String,
		isIndexNumber: Boolean,
		isDisabled: Boolean,
		sortDesc: Boolean,
		sortBy: String,
		filterClasses: Object,
	},
	computed: {
		/**
		 * Виводимо лише ті хедери, у яких func === true
		 * @returns {Array}
		 */
		headersWithFunc() {
			return (this.headers || []).filter(function(item) {
				return !!(item && item.func === true);
			});
		},
		/**
		 * Швидкий доступ до header по valueFilter
		 * @returns {Object<string, Object>}
		 */
		headersByValueFilter() {
			const map = {};
			(this.headers || []).forEach(function(h) {
				if (h && h.valueFilter) map[h.valueFilter] = h;
			});
			return map;
		},

		/**
		 * Побудова списку “Selected filters” з filterModList + headers
		 * @returns {Array<{key: string, text: string, model: string, items: Array<{key: string, value: string}>}>}
		 */
		selectedFilters() {
			const self = this;
			const list = [];
			const mod = this.filterModList || {};
			const keys = Object.keys(mod);

			keys.forEach(function(filterKey) {
				const header = self.headersByValueFilter[filterKey];
				if (!header) return;

				const model = (header.model && header.model.value) ? header.model.value : "list";
				const text = header.text || filterKey;

				const items = self.formatSelectedItems(filterKey, model, mod[filterKey]);

				if (items && items.length) {
					list.push({
						key: filterKey,
						text: text,
						model: model,
						items: items,
					});
				}
			});

			return list;
		},
	},

	data() {
		return {
			isCloseChildren: null,
			filterModList: {},
			page: 1,
			filterClassesMod: {},
			filterTableKey: {},
		};
	},
	methods: {
		onDrawerClose() {
			this.$emit("updateCloseDialogAllFilter");
		},
		onSave() {
			const filter = this.filterModList;
			const filterClass = this.filterClassesMod;

			this.$emit("updateSendAllFilter", { filter, filterClass } );
		},
		changeSort({ key, value, model }) {
			switch (model) {
				case "date":
					this.$set(this.filterModList, key, value);
					this.$set(this.filterClassesMod, key, !!(value && value.from));
					break;

				case "number":
					this.$set(this.filterModList, key, value);
					this.$set(this.filterClassesMod, key, !!(value && value.type));
					break;

				case "note":
					this.$set(this.filterModList, key, value);
					this.$set(this.filterClassesMod, key, !!(value && value.length));
					break;

				case "options":
					this.$set(this.filterModList, key, Number(value));
					this.$set(this.filterClassesMod, key, !!Number(value));
					break;

				case "address":
					this.$set(this.filterModList, key, (value || []).map(function(item) {
						return item; 
					}));
					this.$set(this.filterClassesMod, key, !!((value || []).length));
					break;

				case "addressType":
					this.$set(this.filterModList, key, value);
					this.$set(this.filterClassesMod, key, !!(value && value.length));
					break;

				case "checkbox":
					this.$set(this.filterClassesMod, key, Number(value));
					this.$set(this.filterModList, key, value);
					break;

				case "list":
					this.$set(this.filterModList, key, (value || []).map(function(item) {
						return item; 
					}));
					this.$set(this.filterClassesMod, key, !!((value || []).length));
					break;

				default:
					this.$set(this.filterModList, key, value);
					this.$set(this.filterClassesMod, key, !!(value && value.length));
			}
			console.log("saved:", key, "model:", model, "value:", value, "isArray:", Array.isArray(value));

		},

		createRefresh(value) {
			console.log('%c [ createRefresh value  ] ', 'color:#bada55', typeof value, value );
			// this.$emit("updateCreateRefresh", value);
		},
		filterCreated(value) {
			console.log('%c [ filterCreated value  ] ', 'color:#bada55', typeof value, value );

			// this.$emit("updateFilterCreated", value);
		},
		onFilteredAll(value) {
			console.log('%c [ onFilteredAll value  ] ', 'color:#bada55', typeof value, value );

			// this.$emit("updateFilteredAll", value);
		},
		onPerLoad(value) {
			console.log('%c [ onPerLoad value  ] ', 'color:#bada55', typeof value, value );

			// this.$emit("updatePerLoad", value);
		},

		filterClassesActive(filterKey) {
			const {
				filter_check_in_empty,
				filter_check_out_empty,
				filter_rout_city,
				filter_rout_state,
			} = this.filterClasses || {};
			return (
				(filterKey === "check_in" && filter_check_in_empty) ||
					(filterKey === "check_out" && filter_check_out_empty) ||
					(filterKey === "routs" && filter_rout_city) ||
					(filterKey === "routs" && filter_rout_state)
			);
		},

		/**
		 * Форматує значення фільтра для відображення у “Selected filters”
		 * @param {string} filterKey - ключ фільтра (наприклад filter_customer)
		 * @param {string} model - list | date | number | any
		 * @param {*} value - значення з filterModList[filterKey]
		 * @returns {Array<{key: string, value: string, raw?: *}>}
		 */
		formatSelectedItems(filterKey, model, value) {
			// list: масив значень (часто id)
			if (model === "list") {
				if (!Array.isArray(value) || !value.length) return [];

				const resolved = value.map((v, idx) => {
					const display = this.getListDisplayValue(filterKey, v);

					return {
						key: String(idx) + "_" + String(v),
						value: String(display),
						raw: v,
					};
				});

				return resolved;
			}

			// date: {from,to}
			if (model === "date") {
				if (!value || (!value.from && !value.to)) return [];

				const fromUi = value.from ? formatDate(value.from) : "";
				const toUi = value.to ? formatDate(value.to) : "";

				const txt = fromUi && toUi
					? `${ fromUi } - ${ toUi }`
					: (fromUi || toUi);

				return [ { key: "date", value: txt } ];
			}

			// number: {type,value}
			if (model === "number") {
				if (!value || !value.type) return [];

				const label = this.getNumberTypeLabel(value.type);
				let txtNumber = "";

				if (value.type === 3 && Array.isArray(value.value)) {
					txtNumber = String(value.value[0]) + " - " + String(value.value[1]);
				} else {
					txtNumber = String(value.value);
				}

				return [ { key: "number", value: label + ": " + txtNumber } ];
			}

			// default fallback
			if (Array.isArray(value)) {
				if (!value.length) return [];
				return value.map(function(v, idx) {
					return { key: String(idx) + "_" + String(v), value: String(v), raw: v };
				});
			}

			if (value === null || typeof value === "undefined" || value === "") return [];
			return [ { key: "default", value: String(value), raw: value } ];
		},

		/**
		 * Текст для number.type
		 * @param {number} type
		 * @returns {string}
		 */
		getNumberTypeLabel(type) {
			switch (Number(type)) {
				case 1:
					return "Less than value (<=)";
				case 2:
					return "Greater than value (>=)";
				case 3:
					return "Between values (-)";
				case 4:
					return "Exact value (=)";
				default:
					return "Value";
			}
		},

		/**
		 * Видалення елемента з Selected filters + з filterModList
		 * - list: видаляємо конкретне значення
		 * - date/number: чистимо весь фільтр
		 * @param {{key: string, model: string}} group
		 * @param {{value: string}} chip
		 * @returns {void}
		 */
		removeSelected(group, chip) {
			if (!group || !group.key) return;

			const key = group.key;
			const model = group.model;
			const val = this.filterModList[key];

			if (model === "list") {
				if (!Array.isArray(val)) return;

				// видаляємо по значенню (працює навіть якщо порядок items інший)
				const idx = val.indexOf(chip.raw);

				if (idx !== -1) val.splice(idx, 1);

				this.$set(this.filterModList, key, val);

				if (!val.length) {
					this.$delete(this.filterModList, key);
					this.$set(this.filterClassesMod, key, false);
				} else {
					this.$set(this.filterClassesMod, key, true);
				}
				return;
			}

			// date/number та інші: чистимо повністю
			this.$delete(this.filterModList, key);
			this.$set(this.filterClassesMod, key, false);

		},
		normalizeKeyForTable(key) {
			if (!key) return key;
			return String(key).indexOf("filter_") === 0 ? key : ("filter_" + key);
		},

		/**
		 * Очистити весь фільтр (group) повністю
		 * @param {{key: string}} group
		 * @returns {void}
		 */
		clearSelectedGroup(group) {
			if (!group || !group.key) return;

			const key = group.key;

			this.$delete(this.filterModList, key);
			this.$set(this.filterClassesMod, key, false);
		},
		/**
		 * Key для примусового remount FilterTable
		 * @param {string} key
		 * @returns {string}
		 */
		getFilterTableKey(key) {
			const v = this.filterTableKey[key] || 0;
			return String(key) + "_" + String(v);
		},

		/**
		 * Збільшує версію — FilterTable перемонтується і синхронізується
		 * @param {string} key
		 * @returns {void}
		 */
		bumpFilterTableKey(key) {
			const v = this.filterTableKey[key] || 0;
			this.$set(this.filterTableKey, key, v + 1);
		},

		/**
		 * Для list-фільтрів: бере label/value з filtersList по id
		 * @param {string} filterKey
		 * @param {*} rawValue
		 * @returns {string}
		 */
		getListDisplayValue(filterKey, rawValue) {
			// Якщо раптом у filterModList вже лежить об'єкт {id,value}
			if (rawValue && typeof rawValue === "object") {
				if (typeof rawValue.value !== "undefined") return String(rawValue.value);
				if (typeof rawValue.name !== "undefined") return String(rawValue.name);
			}

			const list = this.filtersList && this.filtersList[filterKey];

			// Якщо filtersList не має довідника — показуємо як є
			if (!Array.isArray(list) || !list.length) return String(rawValue);

			// Якщо це не масив об'єктів — теж показуємо як є
			const first = list[0];
			const isObjectList = first && typeof first === "object" && ("id" in first) && ("value" in first);
			if (!isObjectList) return String(rawValue);

			// Пошук match по id
			const rawStr = String(rawValue);
			const found = list.find(function(item) {
				return item && String(item.id) === rawStr;
			});

			return found && typeof found.value !== "undefined" ? String(found.value) : String(rawValue);
		},
		isFilterSelected(key, model) {
			const val = this.filterModList[key];

			switch (model) {
				case 'date':
					return !!(val && (val.from || val.to));
				case 'number':
					return !!(val && val.type);
				case 'options':
					return !!Number(val);
				case 'checkbox':
					return !!Number(val);
				case 'note':
					return !!(val && val.length);
				case 'address':
				case 'list':
					return Array.isArray(val) && val.length > 0;
				default:
					return Array.isArray(val) ? val.length > 0 : !!val;
			}
		},

	},

	watch: {
		/**
		 * Синхронізація локального стану з батьківським filterMod
		 * @param {Object} val
		 * @returns {void}
		 */
		filterMod: {
			immediate: true,
			deep: true,
			handler(val) {
				// коли батько скинув фільтри — тут стане дефолт/пусто
				this.filterModList = val ? JSON.parse(JSON.stringify(val)) : {};
				this.filterClassesMod = {};
				this.filterTableKey = {};
			}
		}
	},

};
</script>

<style scoped lang="scss">

.wrapAllFilters {
	display: flex;
	flex-direction: column;
	gap: 10px;
	.cardItem {
		background: var(--card-bg-opacity);
		border-radius: 4px;
		padding: 15px;
	}
	.selectedFiltersWrap {
		display: block;

		.head {
			margin-bottom: 10px;
			color: var(--card-color-sub-title);
		}
		.main {
			display: flex;
			flex-wrap: wrap;
			gap: 10px;

			.selItem {
				background: var(--card-bg-opacity);
				border-radius: 4px;
				padding: 10px;
				width: 300px;
				.nameRow {
					display: flex;
					align-items: center;
					justify-content: space-between;
					gap: 10px;
					margin-bottom: 8px;

					.name {
						font-weight: bold;
						color: var(--base-orange);
					}

					.clearAllBtn {
						border: none;
						background: transparent;
						cursor: pointer;
						font-size: 12px;
						opacity: 0.8;
						padding: 2px 6px;
						border-radius: 4px;

						&:hover {
							opacity: 1;
							background: var(--card-bg-opacity);
						}
					}
				}
				.wrap {
					display: flex;
					gap: 8px;
					flex-direction: column;

					.item {
						display: inline-flex;
						align-items: center;
						gap: 4px;

						.itemContent {
							padding: 2px 6px;
							border-radius: 4px;
							background: var(--card-bg-opacity);
							display: inline-flex;
							align-items: center;
							gap: 4px;
							.value {
								font-size: 12px;
							}
							.delete {
								color: var(--card-color-sub-title);
								display: flex;
								align-items: center;
								justify-content: center;
								transition: .3s;
								cursor: pointer;
								&:hover {
									color: var(--base-red);
								}
							}
						}
					}
				}

			}

			> .item {
				.wrapper {
					transition: 0.3s;
					background: var(--card-bg-opacity);
					opacity: 0.8;
					padding: 3px 6px;
					border-radius: 4px;
					display: flex;
					align-items: center;
					gap: 4px;
				}
				&.active {
					.wrapper {
						background: var(--base-green2);
					}
				}
			}
		}

	}
	.listFiltersWrap {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: 10px;
	}
	.listF {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 10px;
	}
	.optionsF {}

}

</style>
